<template>
    <div class="home">
        <b-img src="images/apple.png" fluid />
        <b-row>
            <b-col cols="auto" class="ml-auto mr-4" style="font-size: smaller;">Bildquelle: AdobeStock</b-col>
        </b-row>
        <span v-html="$t('presentation.procurement')" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'einkauf',
        data() {
            return {};
        },
        computed: {
            ...mapGetters({
                auth: 'auth/auth'
            })
        }
    }
</script>